var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 17.1202C22.0532 17.1202 23.7188 15.4545 23.7188 13.3999C23.7188 11.3452 22.0532 9.67969 19.9986 9.67969C17.9439 9.67969 16.2783 11.3452 16.2783 13.3999C16.2783 15.4545 17.9439 17.1202 19.9986 17.1202Z",
    fill: "#B7CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0449 5.70521L35.0449 30.4219L31.6949 32.5385L31.6949 4.17187L35.0449 5.70521Z",
    fill: "#A020FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2082 32.7495H28.8887C27.4998 32.7495 26.1804 33.2877 25.2082 34.2599L22.2394 37.194C20.8852 38.5308 18.6804 38.5308 17.3263 37.194L14.3575 34.2599C13.3852 33.2877 12.0484 32.7495 10.6769 32.7495H9.37484C6.49289 32.7495 4.1665 30.4405 4.1665 27.5933V8.65229C4.1665 5.80507 6.49289 3.49609 9.37484 3.49609H30.2082C33.0901 3.49609 35.4165 5.80507 35.4165 8.65229V27.5933C35.4165 30.4232 33.0901 32.7495 30.2082 32.7495Z",
    stroke: "#081E54",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7913 17.3715C22.0253 17.3715 23.8364 15.5604 23.8364 13.3263C23.8364 11.0922 22.0253 9.28125 19.7913 9.28125C17.5572 9.28125 15.7461 11.0922 15.7461 13.3263C15.7461 15.5604 17.5572 17.3715 19.7913 17.3715Z",
    stroke: "#081E54",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7356 27.1987C26.7356 24.0737 23.6279 21.5391 19.7911 21.5391C15.9543 21.5391 12.8467 24.0737 12.8467 27.1987",
    stroke: "#081E54",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/Details.c4529505ae7d5d4d4bc52b8b1d8ec31f.svg";
export { ForwardRef as ReactComponent };